"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppVersionDtoPlatformEnum = void 0;
exports.instanceOfAppVersionDto = instanceOfAppVersionDto;
exports.AppVersionDtoFromJSON = AppVersionDtoFromJSON;
exports.AppVersionDtoFromJSONTyped = AppVersionDtoFromJSONTyped;
exports.AppVersionDtoToJSON = AppVersionDtoToJSON;
exports.AppVersionDtoToJSONTyped = AppVersionDtoToJSONTyped;
/**
 * @export
 */
exports.AppVersionDtoPlatformEnum = {
    Ios: 'ios',
    Android: 'android'
};
/**
 * Check if a given object implements the AppVersionDto interface.
 */
function instanceOfAppVersionDto(value) {
    if (!('platform' in value) || value['platform'] === undefined)
        return false;
    if (!('minimumRequiredVersion' in value) || value['minimumRequiredVersion'] === undefined)
        return false;
    if (!('latestVersion' in value) || value['latestVersion'] === undefined)
        return false;
    if (!('appUrl' in value) || value['appUrl'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function AppVersionDtoFromJSON(json) {
    return AppVersionDtoFromJSONTyped(json, false);
}
function AppVersionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'platform': json['platform'],
        'minimumRequiredVersion': json['minimumRequiredVersion'],
        'latestVersion': json['latestVersion'],
        'appUrl': json['appUrl'],
        'message': json['message'],
    };
}
function AppVersionDtoToJSON(json) {
    return AppVersionDtoToJSONTyped(json, false);
}
function AppVersionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'platform': value['platform'],
        'minimumRequiredVersion': value['minimumRequiredVersion'],
        'latestVersion': value['latestVersion'],
        'appUrl': value['appUrl'],
        'message': value['message'],
    };
}
